import React from 'react';
import './footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footerz">
      <div className="containerz">
        <div className="rowz">
          <div className="footer-colz">
            <div className="footer-colz1">
              <h4>About VREON</h4>
              <ul className='ulabout'>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/service">Our services</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/portfolio">Portfolio</Link></li>
                {/* <li><Link to="/form">Careers</Link></li> */}
              </ul>
            </div>
          </div>
          <div className="footer-colz">
            <div className="footer-colz2">
              <h4>get help</h4>
              <ul>
                <li><Link to="/tc">Terms and condition</Link></li>
                <li><Link to="/dis">Disclaimer Policy</Link></li>
                <li><Link to="/pri">Privacy Policy</Link></li>
                <li><Link to="/ref">Refund policy</Link></li>
              </ul>
            </div>

          </div>
          <div className="footer-colz">
            <div className="footer-colz3">
              {/* <h4>Registered office</h4>
              <ul style={{ listStyle: 'none' }}>
                <li>VREON TECH INDIA PRIVATE LIMITED</li>
                <li>No #43, Balaji  Nagar,</li>
                <li>5th Street,Alwarthirunagar,</li>
                <li>Valasarawakkam,  Chennai  600087,</li>
                <li>Tamilnadu, India.</li>
              </ul> */}
            </div>
          </div>

          <div className="footer-colz">
            <div className="footer-colz4">
              <h4 className='office'>office</h4>
              <ul style={{ listStyle: 'none' }}>
                <li>VREON TECH INDIA PRIVATE LIMITED</li>
                <li>Old No.36-G, New No.1/36-3,</li>
                <li>North Parade Road, St. Thomas Mount,</li>
                <li>Chennai - 600016,</li>
                <li>Tamilnadu, India</li>
              </ul>
            </div>
          </div>
          <div className="footer-col-follow-usz">
            <h4>Follow us</h4>
            <div className="social-linksz">
              <div>
                <a target='Blank' href="https://in.linkedin.com/company/vreon-tech-india-pvt-ltd"><img className="image-icon1m" alt="" src="/linkedin1.png" /></a>
                <a target='Blank' href="https://www.facebook.com/vreontech"><img className="image-icon2m" alt="" src="/facebook.png" /></a>
                <img className="image-icon3m" alt="" src="/instagram.png" />
                <a target='Blank' href="https://www.twitter.com/VReon_Tech"><img className="image-icon4m" alt="" src="/twitter.png" /></a>
                <a target='Blank' href="https://wa.me/+919626911311"><img className="image-icon5m" alt="" src="/whatsapp.png" /></a>
              </div>


            </div>

          </div>
        </div>
        <div className="bottom-barz">
          <p>© 2026 VREON TECH, ALL RIGHTS RESERVED</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
